import { render, staticRenderFns } from "./BsGridRow.vue?vue&type=template&id=9bfb792c&"
import script from "./BsGridRow.vue?vue&type=script&lang=js&"
export * from "./BsGridRow.vue?vue&type=script&lang=js&"
import style0 from "./BsGridRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports